import React from "react";

const MSMEComplianceNews = () => {
  return (
    <div className="bg-black min-h-screen p-4 text-white">
      <h1 className="text-2xl sm:text-3xl font-bold mb-4">MSME Compliance News</h1>

      <p className="mb-4 text-gray-300">
        Stay updated with the latest news, notifications, and announcements affecting MSMEs. Check this page regularly for updates from government and regulatory bodies.
      </p>

      {/* Dummy news items */}
      <div className="space-y-3">
        {[
          "Govt extends GST return deadlines for Q1 2026",
          "EPF & ESI portal maintenance scheduled this week",
          "New Labour Code notifications released for Maharashtra",
          "FSSAI issues new food safety advisory",
          "Udyam Registration portal introduces instant verification feature"
        ].map((news, index) => (
          <div
            key={index}
            className="bg-gray-900 p-3 rounded-md shadow hover:bg-gray-800 transition cursor-pointer"
          >
            {news}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MSMEComplianceNews;